<template>
  <div class="row search-bar">
    <div class="search-container">
      <div class="search-align">
        <div class="export-wrapper">
          <b-button class='button-sidenav-toggle' @click="sidenavToggle" v-if="!$store.state.sidebarStatus"><i class="material-icons">filter_list</i></b-button>
          <b-button class="btn-export-container"  @click="print" style="margin-right:10px" v-if="!$store.state.csv_data">
            <a 
              class="button-export"
            >
              <span v-if="!isLoading">Create CSV</span>
              <span v-if="isLoading">Loading...</span>
              <i class="material-icons">insert_drive_file</i>
            </a>
          </b-button>
          <b-button class="btn-export-container text-white" v-if="$store.state.csv_data" style="background-color:#609151">
            <download-csv 
              class="button-export"
              :data="$store.state.csv_data"
              name="isupplier-data-export.csv"
            >
              <span>Export To CSV</span>
              <i class="material-icons">insert_drive_file</i>
            </download-csv>
          </b-button>
        </div>

        <div class="inner-form d-flex align-items-center justify-content-between">
          <div class="input-field flex-grow">
            <b-form-input type="text" class="search" placeholder="Any Keyword" v-model="$store.state.searchBar" @keydown.native="enterSearch" />
          </div>

          <div class="input-field input-btn flex-grow">
            <b-button class="btn-search" @click="runSearch">
              <i class="material-icons">search</i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
export default {
  name: 'SearchBar',
  data(){
    return {
      search : null,
      csv_data : null,
      isLoading : false
    }
  },
  methods: {
    print(){
      if(this.$store.state.itemTable && this.$store.state.itemTable.length > 0){
        this.isLoading = true
        const item = this.$store.state.itemTable
        let itemCopy = [...this.$store.state.itemTable]
        let newItem = []

        for(let i in item){
          newItem.push(item[i])
        }
  
        for(let i in item){
          newItem[i]['SCORE_FOR_K3L_PREQUALIFICATION'] = Number(item[i]['SCORE_FOR_K3L_PREQUALIFICATION']).toFixed(0)
          newItem[i]['SPM Scoring'] = this.spmScoring(item[i].SPM)
          newItem[i]['Vendor Category'] = this.vendorCategory(item[i].SPM)
          newItem[i]['Total Project'] = this.spmScoringTotalProject(item[i].SPM)
          newItem[i]['CSI Scoring'] = this.calCsi(item[i].csi)
          newItem[i]['CSI Final Adj'] = this.csiFinalAdj(item[i].csi)
          newItem[i]['Total Event'] = item[i].EVENT && item[i].EVENT.length
          newItem[i]['Event Participated'] = this.eventParticipated(item[i].EVENT)
          newItem[i]['Event Awarded'] = this.eventAwarded(item[i].EVENT)
          newItem[i]['PO Type'] = this.getPoType(item[i].po)
          newItem[i]['Total PO Value IDR'] = this.totalPoValue(item[i].po)
          newItem[i]['Total PO Release'] =  item[i].po && item[i].po.length
          newItem[i]['Risk Category'] = this.k3lRiskCategory(item[i].SCORE_FOR_K3L_PREQUALIFICATION)
          newItem[i]['K3L Remaining Days'] = this.k3lRemainingDays(item[i].K3L_PREQ_END_DATE)
        }

        for(let i in newItem){
          delete newItem[i]["SPM"]
          delete newItem[i]["po"]
          delete newItem[i]["EVENT"]
          delete newItem[i]["PIC"]
        }
        this.$store.commit('SET_CSV_DATA', newItem)
        this.isLoading = false
        this.$ga.event({
          eventCategory: 'Download CSV',
          eventAction: 'click',
          eventLabel: 'EXPORT TO CSV'
        });
      }
    },
    k3lRemainingDays(item){
      const k3lEnd = new Date(item)
        const convertTime = 1000*60*60*24
        if(k3lEnd && ((k3lEnd.getTime() - new Date().getTime())/convertTime) <= 60 && ((k3lEnd.getTime() - new Date().getTime())/convertTime) >= 0){
          return parseInt(((k3lEnd.getTime() - new Date().getTime())/convertTime))
        }
        return '-'
    },
     k3lRiskCategory(score) {
      if (score && score > 0) {
        if (score <= 24) return "LOW C2";
        if (score > 24 && score < 35) return "LOW C1";
        if (score >= 35 && score < 50) return "MEDIUM B2";
        if (score >= 50 && score < 70) return "MEDIUM B1";
        if (score >= 70 && score <= 100) return "HIGH";
      }
      return "-";
    },
    totalPoValue(item){
      let count = 0
      let totalItem = 0
			if(item){
				item.map(list => {
					count += parseInt(list.TOTAL_VALUE_IDR)
					totalItem++
				})
				if(totalItem > 0){
					let idr = numeral(parseInt(count)).format('0,0.00')
					let newIdr = ''
					idr.split('').map(list => {
						if(list == ','){
							newIdr += '.'
						} else if(list == '.') {
							newIdr += ','
						} else {
							newIdr += list
						}
					})
					return newIdr
				}
			}
			return 0
    },
    getPoType(value) {
      let data = [];
      if (value) {
        value.map(list => {
          data.push(list.PO_TYPE);
        });
        return this.removeDuplicates(data);
      }
      return "-";
    },
    removeDuplicates(array) {
      const data = array.filter((a, b) => array.indexOf(a) === b);
      let newData = "";
      if (data && data.length > 0) {
        for (let i in data) {
          if (i == 0) {
            newData += data[i];
          } else {
            newData += `, ${data[i]}`;
          }
        }
        return newData;
      }
      return "-";
    },
    eventParticipated(event) {
      if(event && event.length > 0){
        const participate =
          event && event.filter(item => item.EVENT_PARTICIPATED > 0);
        return participate.length;
      } 
      return 0
    },
    eventAwarded(event) {
      if(event && event.length > 0){
        const participate = event && event.filter(item => item.EVENT_AWARDED > 0);
        return participate.length;
      }
      return 0
    },
    calCsi(value) {
      let count = 0;
      let item = 0;
      value &&
        value.map(list => {
          if (list.CSI_SCORE_AVG && typeof Number) {
            count += Number(list.CSI_SCORE_AVG);
            item++;
          }
        });

      if (item > 0) {
        return Math.round(count / item);
      }
      return "-";
    },
    csiFinalAdj(data) {
      if (data && data.length > 0) {
        if (Math.round(this.calCsi(data)) <= 1) return "CSI Sangat Buruk";
        if (Math.round(this.calCsi(data)) == 2) return "CSI Tidak Memuaskan";
        if (Math.round(this.calCsi(data)) == 3) return "CSI Cukup Memuaskan";
        if (Math.round(this.calCsi(data)) == 4) return "CSI Memuaskan";
        if (Math.round(this.calCsi(data)) == 5) return "CSI Sangat Memuaskan";
      }
      return "-";
    },
    vendorCategory(score) {
      if (this.spmScoring(score) >= 95) {
        return "Sangat Memuaskan";
      } else if (this.spmScoring(score) >= 80 && this.spmScoring(score) < 95) {
        return "Memuaskan";
      } else if (this.spmScoring(score) >= 70 && this.spmScoring(score) < 80) {
        return "Cukup Memuaskan";
      } else if (this.spmScoring(score) > 50 && this.spmScoring(score) < 70) {
        return "Tidak Memuaskan";
      } else if (this.spmScoring(score) >= 0 && this.spmScoring(score) <= 50) {
        return "Sangat Buruk";
      }
    },
    spmScoring(value) {
      if (value && value.length > 0) {
        let obj = {};
        let count = 0;
        let total = 0;

        value.map(item => {
          if (obj[item.PROJECT_NAME] === undefined) {
            obj[item.PROJECT_NAME] = {
              avg: item.AVG_GRADE !== null && item.AVG_GRADE > 0 ? [item.AVG_GRADE] : []
            };
          } else {
            obj[item.PROJECT_NAME]["avg"] = item.AVG_GRADE !== null && item.AVG_GRADE > 0
              ? [...obj[item.PROJECT_NAME]["avg"], item.AVG_GRADE]
              : obj[item.PROJECT_NAME]["avg"];
          }
        });

        let newObj = Object.values(obj);
        newObj &&
          newObj.map(item => {
            count += item.avg.reduce((a, b) => Number(a) + Number(b), 0) / item.avg.length;
            total++;
          });

        if (total > 0) return Math.round(count / total);
      }
      return "-";
    },
    spmScoringTotalProject(value) {
      if (value && value.length > 0) {
        const unique = [...new Set(value.map(item => item.PROJECT_NAME))];
        return unique.length;
      }
      return "-";
    },
    sidenavToggle(){
      this.$store.dispatch('toggleSidebar', true)
    },
    enterSearch(event){
      if(event.which === 13){
        this.runSearch()
      }
    },
    runSearch(){
      this.$store.dispatch('setSearchTable', this.$store.state.searchBar)
      this.$ga.event({
          eventCategory: 'SEARCH',
          eventAction: 'click',
          eventLabel: 'SEARCH'
        });
    }
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/layouts/default.scss';
</style>
